export default __webpack_public_path__ + "static/media/Lato-Regular.80c07943.ttf";